import type { BoxProps } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";
import type { ReactElement } from "react";

export function VSep(p?: BoxProps): ReactElement {
    return (
        <Box
            borderRight="1px solid var(--chakra-colors-blackAlpha-400)"
            height="30px"
            {...p}
        />
    );
}

export function FlexSpc(p?: BoxProps) {
    return <Box flexGrow={1} {...p} />;
}
